export const SETTING_USER = "SETTING_USER";
export const SETTING_ACCOUNT = "SETTING_ACCOUNT";
export const SETTING_ACCOUNT_CLIENT = "SETTING_ACCOUNT_CLIENT";
export const SETTING_ACCOUNT_FREELANCER = "SETTING_ACCOUNT_FREELANCER";
export const SETTING_JOB = "SETTING_JOB";
export const SETTING_CONTRACT = "SETTING_CONTRACT";
export const SETTING_FORM_FIELD = "SETTING_FORM_FIELD";
export const SETTING_PROPOSAL = "SETTING_PROPOSAL";
export const SETTING_PORTFOLIO = "SETTING_PORTFOLIO";
export const USER = "USER";
export const USER_IDENTIFIER = "USER_IDENTIFIER";
export const ACCOUNT = "ACCOUNT";
export const JOB = "JOB";
export const JOB_METRIC = "JOB_METRIC";
export const JOB_ACCOUNT_CONTEXT = "JOB_ACCOUNT_CONTEXT";
export const INVITATION = "INVITATION";
export const JOB_ANALYTIC = "JOB_ANALYTIC";
export const CONTRACT = "CONTRACT";
export const CONTRACT_MILESTONE = "CONTRACT_MILESTONE";
export const CONTRACT_MILESTONE_SUBMISSION = "CONTRACT_MILESTONE_SUBMISSION";
export const CONTRACT_SUBMISSION = "CONTRACT_SUBMISSION";
export const CONTRACT_PAYMENT = "CONTRACT_PAYMENT";
export const CONTRACT_PAYMENT_REQUEST = "CONTRACT_PAYMENT_REQUEST";
export const CONTRACT_MILESTONE_PAYMENT = "CONTRACT_MILESTONE_PAYMENT";
export const CONTRACT_MILESTONE_PAYMENT_REQUEST =
  "CONTRACT_MILESTONE_PAYMENT_REQUEST";
export const PROPOSAL = "PROPOSAL";
export const CURRENCY = "CURRENCY";
export const BOOKMARK = "BOOKMARK";
export const NOTIFICATION = "NOTIFICATION";
export const NOTIFICATION_EVENT = "NOTIFICATION_EVENT";
export const NOTIFICATION_PREFERENCE = "NOTIFICATION_PREFERENCE";
export const PAYMENT = "PAYMENT";
export const PAYMENT_METHOD = "PAYMENT_METHOD";
export const PAYMENT_PROVIDER = "PAYMENT_PROVIDER";
export const PAYMENT_PROVIDER_COUNTRY = "PAYMENT_PROVIDER_COUNTRY";
export const PAYMENT_PROVIDER_CURRENCY = "PAYMENT_PROVIDER_CURRENCY";
export const WALLET = "WALLET";
export const PORTFOLIO = "PORTFOLIO";
export const PORTFOLIO_PROJECT = "PORTFOLIO_PROJECT";
export const SUPPORT_CONTACT_US = "SUPPORT_CONTACT_US";
export const CAREER = "CAREER";
export const CAREER_APPLICATION = "CAREER_APPLICATION";
